export const PlanInfo = {
  plan1: {
    totalBackLinks: 40,
    bklCrawledPerMonth: 20,
    totalbklCrawled: 0,
    domains: 1,
    num_users: 0,
    frequency: "Weekly",
    deleteDomain: 1,
    branding: false,
    name: "Free",
    price: "0",
    priceId: "",
    indexmenow: 0,
  },
  plan2: {
    totalBackLinks: 500,
    bklCrawledPerMonth: 250,
    totalbklCrawled: 0,
    domains: 5,
    num_users: 0,
    frequency: "Weekly",
    deleteDomain: 1,
    branding: false,
    name: "Tier 1",
    price: "39",
    priceId: process.env.REACT_APP_BLC_TIER1,
    indexmenow: 0, // In MRR, it is STARTER plan
  },
  plan3: {
    totalBackLinks: 5000,
    bklCrawledPerMonth: 2500,
    totalbklCrawled: 0,
    domains: 20,
    num_users: 0,
    frequency: "Weekly",
    deleteDomain: 2,
    branding: false,
    name: "Tier 2",
    price: "78",
    priceId: process.env.REACT_APP_BLC_TIER2,
    indexmenow: 0,
  },
  plan4: {
    totalBackLinks: 8000,
    bklCrawledPerMonth: 4000,
    totalbklCrawled: 0,
    domains: 35,
    num_users: 0,
    frequency: "Weekly",
    deleteDomain: 3,
    branding: false,
    name: "Tier 3",
    price: "117",
    priceId: process.env.REACT_APP_BLC_TIER3,
    indexmenow: 1,
  },
  plan5: {
    totalBackLinks: 13000,
    bklCrawledPerMonth: 6500,
    totalbklCrawled: 0,
    domains: 60,
    num_users: 0,
    frequency: "Weekly",
    deleteDomain: 6,
    branding: true,
    name: "Tier 4",
    price: "156",
    priceId: process.env.REACT_APP_BLC_TIER4,
    indexmenow: 1,
  },
  plan6: {
    totalBackLinks: 16000,
    bklCrawledPerMonth: 8000,
    totalbklCrawled: 0,
    domains: 90,
    num_users: 2,
    frequency: "Weekly",
    deleteDomain: 9,
    branding: true,
    name: "Tier 5",
    price: "195",
    priceId: process.env.REACT_APP_BLC_TIER5,
    indexmenow: 1,
  },
  plan7: {
    totalBackLinks: 22000,
    bklCrawledPerMonth: 11000,
    totalbklCrawled: 0,
    domains: 130,
    num_users: 4,
    frequency: "Weekly",
    deleteDomain: 13,
    branding: true,
    name: "Tier 6",
    price: "234",
    priceId: "",
    indexmenow: 1,
  },
  plan8: {
    totalBackLinks: 25000,
    bklCrawledPerMonth: 12500,
    totalbklCrawled: 0,
    domains: 160,
    num_users: 6,
    frequency: "Weekly",
    deleteDomain: 16,
    branding: true,
    name: "Tier 7",
    price: "273",
    priceId: "",
    indexmenow: 1,
  },
  plan9: {
    totalBackLinks: 30000,
    bklCrawledPerMonth: 15000,
    totalbklCrawled: 0,
    domains: 200,
    num_users: 9,
    frequency: "Weekly",
    deleteDomain: 20,
    branding: true,
    name: "Tier 8",
    price: "312",
    priceId: "",
    indexmenow: 1,
  },
  plan10: {
    totalBackLinks: 33000,
    bklCrawledPerMonth: 16500,
    totalbklCrawled: 0,
    domains: 250,
    num_users: 14,
    frequency: "Weekly",
    deleteDomain: 25,
    branding: true,
    name: "Tier 9",
    price: "351",
    priceId: "",
    indexmenow: 1,
  },
  plan11: {
    totalBackLinks: 40000,
    bklCrawledPerMonth: 20000,
    totalbklCrawled: 0,
    domains: 500,
    num_users: 19,
    frequency: "Weekly",
    deleteDomain: 50,
    branding: true,
    name: "Tier 10",
    price: "390",
    priceId: "",
    indexmenow: 1,
  },
  plan12: {
    totalBackLinks: 45000,
    bklCrawledPerMonth: 22500,
    totalbklCrawled: 0,
    domains: 600,
    num_users: 19,
    frequency: "Weekly",
    deleteDomain: 55,
    branding: true,
    name: "Tier 11",
    price: "429",
    priceId: "",
    indexmenow: 1,
  },
  plan13: {
    totalBackLinks: 50000,
    bklCrawledPerMonth: 25000,
    totalbklCrawled: 0,
    domains: 650,
    num_users: 19,
    frequency: "Weekly",
    deleteDomain: 60,
    branding: true,
    name: "Tier 12",
    price: "468",
    priceId: "",
    indexmenow: 1,
  },
  plan14: {
    totalBackLinks: 55000,
    bklCrawledPerMonth: 27500,
    totalbklCrawled: 0,
    domains: 750,
    num_users: 19,
    frequency: "Weekly",
    deleteDomain: 75,
    branding: true,
    name: "Tier 13",
    price: "507",
    priceId: "",
    indexmenow: 1,
  },
  plan15: {
    totalBackLinks: 60000,
    bklCrawledPerMonth: 30000,
    totalbklCrawled: 0,
    domains: 850,
    num_users: 19,
    frequency: "Weekly",
    deleteDomain: 85,
    branding: true,
    name: "Tier 14",
    price: "546",
    priceId: "",
    indexmenow: 1,
  },
  plan16: {
    bklCrawledPerMonth: 35000,
    totalBackLinks: 70000,
    totalbklCrawled: 0,
    domains: 1001,
    num_users: 19,
    frequency: "Weekly",
    deleteDomain: 100,
    branding: true,
    name: "Tier 15",
    price: "585",
    priceId: "",
    indexmenow: 1,
  },
  plan17: {
    bklCrawledPerMonth: 36500,
    totalBackLinks: 73000,
    totalbklCrawled: 0,
    domains: 1041,
    num_users: 19,
    frequency: "Weekly",
    deleteDomain: 104,
    branding: true,
    name: "Tier 16",
    price: "624",
    priceId: "",
    indexmenow: 1,
  },
  plan18: {
    bklCrawledPerMonth: 39000,
    totalBackLinks: 78000,
    totalbklCrawled: 0,
    domains: 1071,
    num_users: 19,
    frequency: "Weekly",
    deleteDomain: 107,
    branding: true,
    name: "Tier 17",
    price: "663",
    priceId: "",
    indexmenow: 1,
  },
  plan19: {
    bklCrawledPerMonth: 40500,
    totalBackLinks: 81000,
    totalbklCrawled: 0,
    domains: 1111,
    num_users: 19,
    frequency: "Weekly",
    deleteDomain: 11,
    branding: true,
    name: "Tier 18",
    price: "702",
    priceId: "",
    indexmenow: 1,
  },
  plan20: {
    bklCrawledPerMonth: 43000,
    totalBackLinks: 86000,
    totalbklCrawled: 0,
    domains: 1161,
    num_users: 19,
    frequency: "Weekly",
    deleteDomain: 116,
    branding: true,
    name: "Tier 19",
    price: "741",
    priceId: "",
    indexmenow: 1,
  },
  plan21: {
    bklCrawledPerMonth: 44500,
    totalBackLinks: 89000,
    totalbklCrawled: 0,
    domains: 1411,
    num_users: 19,
    frequency: "Weekly",
    deleteDomain: 141,
    branding: true,
    name: "Tier 20",
    price: "780",
    priceId: "",
    indexmenow: 1,
  },
  plan22: {
    bklCrawledPerMonth: 47000,
    totalBackLinks: 94000,
    totalbklCrawled: 0,
    domains: 1511,
    num_users: 29,
    frequency: "Weekly",
    deleteDomain: 151,
    branding: true,
    name: "Tier 21",
    price: "819",
    priceId: "",
    indexmenow: 1,
  },
  plan23: {
    bklCrawledPerMonth: 48500,
    totalBackLinks: 97000,
    totalbklCrawled: 0,
    domains: 1561,
    num_users: 29,
    frequency: "Weekly",
    deleteDomain: 156,
    branding: true,
    name: "Tier 22",
    price: "858",
    priceId: "",
    indexmenow: 1,
  },
  plan24: {
    bklCrawledPerMonth: 51000,
    totalBackLinks: 102000,
    totalbklCrawled: 0,
    domains: 1661,
    num_users: 29,
    frequency: "Weekly",
    deleteDomain: 166,
    branding: true,
    name: "Tier 23",
    price: "897",
    priceId: "",
    indexmenow: 1,
  },
  plan25: {
    bklCrawledPerMonth: 52500,
    totalBackLinks: 105000,
    totalbklCrawled: 0,
    domains: 1761,
    num_users: 29,
    frequency: "Weekly",
    deleteDomain: 176,
    branding: true,
    name: "Tier 24",
    price: "936",
    priceId: "",
    indexmenow: 1,
  },
  plan26: {
    bklCrawledPerMonth: 55000,
    totalBackLinks: 110000,
    totalbklCrawled: 0,
    domains: 2000,
    num_users: 29,
    frequency: "Weekly",
    deleteDomain: 200,
    branding: true,
    name: "Tier 25",
    price: "975",
    priceId: "",
    indexmenow: 1,
  },
  // Starter: {
  //   price: "15",
  //   totalBackLinks: 5000,
  //   bklCrawledPerMonth: 2500,
  //   totalbklCrawled: 0,
  //   domains: 20,
  //   num_users: 0,
  //   frequency: "Weekly",
  //   deleteDomain: 2,
  //   branding: false,
  //   name: "Starter",
  //   priceId: process.env.REACT_APP_BLC_TIER1, // In MRR, it is STARTER plan
  // },
  // Advanced: {
  //   price: "29",
  //   totalBackLinks: 8000,
  //   bklCrawledPerMonth: 4000,
  //   totalbklCrawled: 0,
  //   domains: 35,
  //   num_users: 0,
  //   frequency: "Weekly",
  //   deleteDomain: 3,
  //   branding: false,
  //   name: "Advanced",
  //   priceId: process.env.REACT_APP_BLC_TIER2,
  // },
  // Pro: {
  //   price: "49",
  //   totalBackLinks: 22000,
  //   bklCrawledPerMonth: 11000,
  //   totalbklCrawled: 0,
  //   domains: 130,
  //   num_users: 4,
  //   frequency: "Weekly",
  //   deleteDomain: 13,
  //   branding: true,
  //   name: "Pro",
  //   priceId: process.env.REACT_APP_BLC_TIER3,
  // },
  // Agency: {
  //   totalBackLinks: 60000,
  //   bklCrawledPerMonth: 30000,
  //   totalbklCrawled: 0,
  //   domains: 850,
  //   num_users: 19,
  //   frequency: "Weekly",
  //   deleteDomain: 85,
  //   branding: true,
  //   name: "Agency",
  //   price: "99",
  //   priceId: process.env.REACT_APP_BLC_TIER4,
  // },
  // AgencyPlus: {
  //   bklCrawledPerMonth: 55000,
  //   totalBackLinks: 110000,
  //   totalbklCrawled: 0,
  //   domains: 2000,
  //   num_users: 29,
  //   frequency: "Weekly",
  //   deleteDomain: 200,
  //   branding: true,
  //   name: "Agency Plus",
  //   price: "149",
  //   priceId: process.env.REACT_APP_BLC_TIER5,
  // },
};

export const PlanInfoViewOnPricingPage = {
  plan1: {
    subscription: "month",
    totalBackLinks: 40,
    bklCrawledPerMonth: 20,
    totalbklCrawled: 0,
    domains: 1,
    num_users: 0,
    frequency: "Weekly",
    deleteDomain: 1,
    branding: false,
    name: "Free",
    price: "0",
    priceId: "",
    equivalentPlan: 1,
  },
  plan3: {
    subscription: "month",
    price: "15",
    totalBackLinks: 5000,
    bklCrawledPerMonth: 2500,
    totalbklCrawled: 0,
    domains: 20,
    num_users: 0,
    frequency: "Weekly",
    deleteDomain: 2,
    branding: false,
    name: "Starter",
    equivalentPlan: 3,
    priceId: process.env.REACT_APP_BLC_TIER1, // In MRR, it is STARTER plan
  },
  plan4: {
    subscription: "month",
    price: "29",
    totalBackLinks: 8000,
    bklCrawledPerMonth: 4000,
    totalbklCrawled: 0,
    domains: 35,
    num_users: 0,
    frequency: "Weekly",
    deleteDomain: 3,
    branding: false,
    name: "Advanced",
    equivalentPlan: 4,
    priceId: process.env.REACT_APP_BLC_TIER2,
  },
  plan7: {
    subscription: "month",
    price: "49",
    totalBackLinks: 22000,
    bklCrawledPerMonth: 11000,
    totalbklCrawled: 0,
    domains: 130,
    num_users: 4,
    frequency: "Weekly",
    deleteDomain: 13,
    branding: true,
    name: "Pro",
    equivalentPlan: 7,
    priceId: process.env.REACT_APP_BLC_TIER3,
  },
  plan15: {
    subscription: "month",
    totalBackLinks: 60000,
    bklCrawledPerMonth: 30000,
    totalbklCrawled: 0,
    domains: 850,
    num_users: 19,
    frequency: "Weekly",
    deleteDomain: 85,
    branding: true,
    name: "Agency",
    equivalentPlan: 15,
    price: "99",
    priceId: process.env.REACT_APP_BLC_TIER4,
  },
  plan26: {
    subscription: "month",
    bklCrawledPerMonth: 55000,
    totalBackLinks: 110000,
    totalbklCrawled: 0,
    domains: 2000,
    num_users: 29,
    frequency: "Weekly",
    deleteDomain: 200,
    branding: true,
    name: "Agency Plus",
    price: "149",
    equivalentPlan: 26,
    priceId: process.env.REACT_APP_BLC_TIER5,
  },
};

// Addons for LTD users
export const addOns = [
  {
    subscription: "month",
    formattedName: "Link Discovery", // This will be visible in frontend. This is only for better readability in UI
    name: "linkAssistant", // This is used in all the programming logics in backend, frontend and crons
    // description: `Discover your backlinks without any need to add MOZ API keys.<br />This is the fastest way to discover your backlinks.<br />You will get 20,000 backlinks per month.`,
    description: `Discover up to 20,000 existing backlinks every month without giving your MOZ API keys.`,
    price: "19",
    priceId: process.env.REACT_APP_LINK_ASSISTANT_ADDON,
  },
  {
    subscription: "month",
    formattedName: "BackLinks Indexing",
    name: "googleIndexing",
    description: `Know the Google indexing status of your BACKLINKS & send for prioritized link indexing.`,
    price: "19",
    priceId: process.env.REACT_APP_GOOGLE_INDEXING_ADDON,
  },
  {
    subscription: "month",
    formattedName: "Website Indexing",
    name: "indexmenow",
    description: `Track the indexing status of your SITE's pages through Google search console & quickly get them indexed, all through your GSC.`,
    price: "9",
    priceId: process.env.REACT_APP_INDEX_ME_ADDON,
    showQtyInput: true,
  },
];
